"use client"

import { Provider } from "react-redux"
import { PersistGate } from "redux-persist/integration/react"
import { FullScreenLoader } from "@/components/ui/full-screen-loader"
import { persistor, store } from "../index"

interface ReduxProviderProps {
  children: React.ReactNode
}

export function ReduxProvider({ children }: ReduxProviderProps) {
  return (
    <Provider store={store}>
      <PersistGate loading={<FullScreenLoader />} persistor={persistor}>
        {children}
      </PersistGate>
    </Provider>
  )
}
